<template>
  <div class="refund-audit">
    <public-title :serviceOrderId="serviceOrderId" :active="active"></public-title>
    <!-- <content-title :type="'audit'"></content-title> -->
    <div class="refund-audit-content">
      <div class="refund-audit-title">
        <!-- 审核中 -->
        <div v-if="serviceOrderStatus===1">
          Please review the Service Order
        </div>
         <!-- 仲裁 -->
        <div v-if="serviceOrderStatus===3">
          Retail has initiated arbitration, you can submit arbitration information
          <span style="color:#262B2F;margin:0px 10px">Countdown</span><span style="color:#FF4812;margin:0px 5px">{{countDown.time}}</span><span style="color:#262B2F;margin:0px 5px">Days</span><span style="color:#FF4812;margin:0px 5px">{{countDown.hour}}</span><span style="color:#262B2F;margin:0px 5px">HRS</span><span style="color:#FF4812;margin:0px 5px">{{countDown.minute}}</span><span style="color:#262B2F;margin:0px 5px">MIN</span><span style="color:#FF4812;margin:0px 5px">{{countDown.second}}</span><span style="color:#262B2F;margin:0px 5px">SEC</span>
        </div>
        <!-- 拒绝退款 -->
        <div v-if="serviceOrderStatus===60 || serviceOrderStatus===61 " style="color:#FF4812">
          You have rejected the after sale application, waiting for the buyer to modify the after sale application
          <span style="color:#262B2F;margin:0px 10px">Countdown</span><span style="color:#FF4812;margin:0px 5px">{{countDown.time}}</span><span style="color:#262B2F;margin:0px 5px">Days</span><span style="color:#FF4812;margin:0px 5px">{{countDown.hour}}</span><span style="color:#262B2F;margin:0px 5px">HRS</span><span style="color:#FF4812;margin:0px 5px">{{countDown.minute}}</span><span style="color:#262B2F;margin:0px 5px">MIN</span><span style="color:#FF4812;margin:0px 5px">{{countDown.second}}</span><span style="color:#262B2F;margin:0px 5px">SEC</span>
        </div>
        <!-- 审核通过 -->
        <div v-if="serviceOrderStatus===2">
          The Service Order has been approved and the refund is pending
        </div>
        <!-- 退款成功 -->
        <div v-if="serviceOrderStatus===4">
          Refund successfully
        </div>
        <!-- 关闭 -->
        <div v-if="serviceOrderStatus===5">
          After sales order closed
        </div>
      </div>
      <!-- 审核中 -->
      <div class="refund-audit-status" v-if="serviceOrderStatus===1">
        <div class="refund-audit-status-content ash">
          <div>Please process the approval order within 1-3 working days!</div>
          <div>If agreed, the platform will refund directly to the retailer</div>
          <div>If you disagree with the refund, you can negotiate with the retailer to revise the refund and re-initiate</div>
          <div class="audit-status-edit">
            <div class="audit-status-edit-button" @click="showReviewDialog(true)">Agree to refund</div>
            <div class="audit-status-edit-button-refund" @click="showReviewDialog(false)">Refusing a refund</div>
          </div>
        </div>
      </div>
      <!-- 仲裁 -->
      <div class="refund-audit-status" v-if="serviceOrderStatus===3">
        <div class="refund-audit-status-content ash">
          <div>Complete the upload of proof materials within 3 days</div>
          <div>After the voucher is uploaded, the platform will process it within 1-3 working days, please wait patiently</div>
          <div class="audit-status-edit">
            <div class="audit-status-edit-button" @click="showArbitrationVisible">Submission of Vouchers</div>
          </div>
        </div>
      </div>
      <!-- 拒绝退款 -->
      <div class="refund-audit-status" v-if="serviceOrderStatus===60 || serviceOrderStatus===61 ">
        <div class="refund-audit-status-content ash">
          <div> The retailer can modify the order within 3 days, and re-initiate the after sale application, if the order has not been modified, the order is closed.</div>
        </div>
      </div>
      <!-- 审核通过 -->
      <div class="refund-audit-status" v-if="serviceOrderStatus===2">
        <div class="refund-audit-status-content ash">
          <div> The ShopVidi platform will process your application within 1-3 working days, please be patient!</div>
        </div>
      </div>
      <!-- 退款成功 -->
      <div class="refund-audit-status" v-if="serviceOrderStatus===4">
        <div class="refund-audit-status-content">
          <div class="refund-succeess-row">
            <div class="title">Refund Success Time</div>
            <div class="value">{{serviceOrder.createAt}}</div>
          </div>
          <div class="refund-succeess-row">
            <div class="title">Refund Total</div>
            <div class="value">${{(serviceOrder.refundTotalAmount).toFixed(2)}}  ({{refundBear}} bear the cost of refunds)<br>
<!--
              <span class="ash">Product Amount: ${{commodityAmount}}(By {{commodityAmountBear}}), Shipping Fee: ${{logisticsFee}}(By {{logisticsFeeBear}}), Fulfillment Service Fee: ${{serviceFee}}(By {{serviceFeeBear}}), ShopVidi Commission: ${{commissionAmount}}(By {{commissionAmountBear}})</span>
-->
            </div>
          </div>
          <div class="refund-succeess-row">
            <div class="title">Return Method</div>
            <div class="value" v-if="payMethod ==='5'">{{ payEmail }}(PayPal Account)</div>
            <div class="value" v-else-if="payMethod !=='1'">Bank account ending in {{cardLast4}}</div>
            <div class="value" v-if="payMethod ==='1'">Net terms:”Refund of Net terms Quota”</div>
          </div>
          <div v-if="payMethod !=='1'">Your refund will be returned to the retailer account according to the original route, and it will take 3-5 working days for the refund to arrive.</div>
          <div v-if="payMethod ==='1'">For the order of using the net 60 term without repayment, you will not be charged a fee for returning products if they are in their original condition.</div>
        </div>
      </div>
      <!-- 关闭 -->
      <div class="refund-audit-status" v-if="serviceOrderStatus===5">
        <div class="refund-audit-status-content ash">
          <div> The back order has been closed and the transaction will proceed normally.</div>
        </div>
      </div>
      <div class="refund-audit-history">
        <span class="medium history-title"> Refund History</span>
        <div v-for="(i,k) in refundHistory" :key="k">
          <!-- status==6 发起售后 status==80 编辑售后单 -->
           <after-sales :message="i" :status="i.status" v-if="i.status===6||i.status===80"></after-sales>
           <!-- 审核通过，拒绝，取消 -->
          <approved  :message="i"  :status="i.status" v-if="i.status===2||i.status===4||i.status===60||i.status===61||i.status===81"></approved>
           <!-- 仲裁 -->
          <arbitration  :message="i"  v-if="i.status===3||i.status===30||i.status===31||i.status===32||i.status===33"  :status="i.status" :serviceOrderMessage="serviceOrder"></arbitration>
           <!-- 关闭 -->
           <close-after-sales v-if="i.status===5||i.status===34" :serviceOrder="serviceOrder"  :message="i"></close-after-sales>
        </div>
      </div>
      <div class="refund-audit-details">
        <refund-details  :serviceOrder="serviceOrder" :orderInfo="orderInfo"></refund-details>
      </div>
      <div>
        <commodity-list v-if="serviceOrderDetail.length>0" :edit="false" :titleType="true"  :serviceOrderDetail="serviceOrderDetail"></commodity-list>
      </div>
    </div>
    <review-dialog :reviewVisible="reviewVisible" :action="action" :reason="reason" @back="back" @reviewServiceOrder="reviewServiceOrder"/>
    <arbitration-dialog :arbitrationVisible="arbitrationVisible" :serviceOrderId="serviceOrderId" @backArbitrationVisible="backArbitrationVisible" @loadData="loadData"/>
  </div>
</template>

<script>

let refundBearMap = new Map([[1,'Brands'],[2,'ShopVidi'],[3,'Retailer']])
// 退款审核通过或拒绝pc-m端
import publicTitle from './components/public-title.vue'
import contentTitle from './components/content-title.vue'
import refundDetails from './components/refund-details.vue'
import commodityList from './components/commodity-list.vue'
import ReviewDialog from './components/review-dialog.vue'
import arbitration from './components/history-list/arbitration.vue'
import afterSales from './components/history-list/after-sales.vue'
import approved from './components/history-list/approved.vue'
import closeAfterSales from './components/history-list/close-after-sales.vue'
import ArbitrationDialog from './components/arbitration-dialog.vue'
import { postAction, getAction, putAction } from '@/api/manage.js'
export default {
  name: 'refundAudit',
  components: {publicTitle, contentTitle, refundDetails, commodityList, ReviewDialog, arbitration, afterSales, approved, closeAfterSales, ArbitrationDialog},
  data() {
    return {
      payEmail:'',//使用PayPal支付时，后台会传PayPal付款账号
      arbitrationVisible: false,
      active: 2,
      serviceOrderStatus: 60,
      action: false,
      reviewVisible: false,
      reason: '',
      serviceOrderId: '',
      serviceOrder: {},
      orderInfo: {},
      refundHistory: [],
      serviceOrderDetail: [],
      payMethod: '2',
      cardLast4: '',
      countDown: {
        time: 0,
        hour: 0,
        minute: 0,
        second: 0
      },
      timer: null,
      refundBear: '', // 退款承担方
      commodityAmount: 0, // 退款商品金额
      commodityAmountBear: '', // 退款商品金额承担方
      logisticsFee: 0, // 退款发货物流金额
      logisticsFeeBear: '', // 退款发货物流承担方
      serviceFee: 0, // 退款履约服务费金额
      serviceFeeBear: '', // 退款商品履约服务费承担方
      commissionAmount: 0, // 退款佣金金额
      commissionAmountBear: '' // 退款佣金承担方
    }
  },
  created() {
    const serviceOrderId = this.$route.query.serviceOrderId
    if (serviceOrderId) {
      this.serviceOrderId = serviceOrderId
    }
    this.loadData()
    console.log('data',this.$data)
  },
  methods: {
    loadData() {
      getAction('/order/api/v0.2/service-orders/service-order-review/' + this.serviceOrderId).then(response => {
        if (response.success) {
          console.log('res',response.result)
          if (response.result) {

            this.serviceOrder = response.result.serviceOrder
            this.serviceOrderDetail = response.result.serviceOrderDetail
            this.orderInfo = response.result.orderInfo
            this.refundHistory = response.result.refundHistory
            this.serviceOrderStatus = this.serviceOrder.status
            if (this.serviceOrderStatus === 4 || this.serviceOrderStatus === 5) {
              this.active = 3
            }
            if (this.serviceOrderStatus === 60 || this.serviceOrderStatus === 61 || this.serviceOrderStatus === 3) {
              this.countdown(this.serviceOrder.countDownTime)
            }
            this.payMethod = response.result.payMethod
            if(this.payMethod === '5') {
              this.payEmail = response.result.payEmail
            }

            //付款卡号
            this.cardLast4 = this.serviceOrder['refundCardNo']
            if (this.serviceOrder['refundCardNo'] && this.serviceOrder['refundCardNo'].length > 4) {
              this.cardLast4 = this.serviceOrder['refundCardNo'].substr(-4)
            }
            // 处理承担方
            this.handleBear()
            // 处理价格
            this.handlePrice()
          }
        } else {
          this.$message.warning(response.message)
        }
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    handleBear() {
      let brandShippingModel = this.serviceOrder.brandShippingModel
      let isFirstOrder = this.serviceOrder.isFirstOrder
      let isShipped = this.serviceOrder.isShipped
      let productStatus = this.serviceOrder.productStatus
      let reasonReturnCate = this.serviceOrder.reasonReturnCate
      let refundUndertaker = this.serviceOrder.refundUndertaker

      // let brandShippingModel = 1
      // let isFirstOrder = true
      // let isShipped = true
      // let productStatus = 2
      // let reasonReturnCate = '履约问题'

      //modify by cpgu 2023/02/03 新增以下逻辑，注释后续判断逻辑 begin
      let refundBearTmp = refundBearMap.get(refundUndertaker);
      let logisticsFeeBearTmp = refundBearMap.get(refundUndertaker)
      if (isFirstOrder && isShipped && productStatus === 1 && reasonReturnCate === '质量问题' && brandShippingModel == 1) {
        logisticsFeeBearTmp = "ShopVidi"
      }
      let commodityAmountBearTmp = refundBearMap.get(refundUndertaker)
      let serviceFeeBearTmp = refundBearMap.get(refundUndertaker)
      this.bear(refundBearTmp, logisticsFeeBearTmp, commodityAmountBearTmp, serviceFeeBearTmp, 'ShopVidi')


      // 首单
     /* if (isFirstOrder) {
        // 发货
        if (isShipped) {
          // 未收货
          if (productStatus === 2) {
            // 平台发货
            if (brandShippingModel === 1) {
              if (reasonReturnCate === '履约问题') {
                this.bear('ShopVidi', 'ShopVidi', 'ShopVidi', 'ShopVidi', 'ShopVidi')
              }
            } else {
              // 自发货
              if (reasonReturnCate === '履约问题') {
                this.bear('Brands', 'Brands', 'Brands', 'Brands', 'ShopVidi')
              }
            }
          } else {
            // 收货
            // 平台发货
            if (brandShippingModel === 1) {
              if (reasonReturnCate === '质量问题') {
                this.bear('Brands', 'ShopVidi', 'Brands', 'Brands', 'ShopVidi')
              } else if (reasonReturnCate === '非质量问题') {
                this.bear('ShopVidi', 'ShopVidi', 'ShopVidi', 'ShopVidi', 'ShopVidi')
              }
            } else {
              // 自发货
              if (reasonReturnCate === '质量问题') {
                this.bear('Brands', 'Brands', 'Brands', 'Brands', 'ShopVidi')
              }
            }
          }
        } else {
          // 未发货，不可能收货，直接判断售后原因，不用判断品品牌发货模式
          if (reasonReturnCate === '履约问题') {
            this.bear('ShopVidi', 'ShopVidi', 'ShopVidi', 'ShopVidi', 'ShopVidi')
          }
        }
      } else {
        // 不为首单.发货
        if (isShipped) {
          // 未收货
          if (productStatus === 2) {
            // 平台发货
            if (brandShippingModel === 1) {
              if (reasonReturnCate === '履约问题') {
                this.bear('ShopVidi', 'ShopVidi', 'ShopVidi', 'ShopVidi', 'ShopVidi')
              }
            } else {
              // 自发货
              if (reasonReturnCate === '履约问题') {
                this.bear('Brands', 'Brands', 'Brands', 'Brands', 'ShopVidi')
              }
            }
          } else {
            // 收货
            // 平台发货
            if (brandShippingModel === 1) {
              if (reasonReturnCate === '质量问题') {
                this.bear('Brands', 'Brands', 'Brands', 'Brands', 'ShopVidi')
              }
            } else {
              // 自发货
              if (reasonReturnCate === '质量问题') {
                this.bear('Brands', 'Brands', 'Brands', 'Brands', 'ShopVidi')
              }
            }
          }
        } else {
          // 未发货，不可能收货，直接判断售后原因，不用判断品品牌发货模式
          if (reasonReturnCate === '履约问题') {
            this.bear('ShopVidi', 'ShopVidi', 'ShopVidi', 'ShopVidi', 'ShopVidi')
          }
        }
      }*/
      //end by cpgu
    },
    bear(refundBear, logisticsFeeBear, commodityAmountBear, serviceFeeBear, commissionAmountBear) {
      this.refundBear = refundBear
      this.logisticsFeeBear = logisticsFeeBear
      this.commodityAmountBear = commodityAmountBear
      this.serviceFeeBear = serviceFeeBear
      this.commissionAmountBear = commissionAmountBear
    },
    /**
     * 处理价格
     */
    handlePrice() {
      let commodityAmountTemp = 0
      let logisticsFeeTemp = 0
      let serviceFeeTemp = 0
      let commissionAmountTemp = 0
      // 循环售后单详情
      this.serviceOrderDetail.forEach(serviceOrder => {
        // 商品
        commodityAmountTemp = commodityAmountTemp + (serviceOrder.goodsAmount - serviceOrder.shopvidiDiscout - serviceOrder.brandDiscout)
        // 物流
        logisticsFeeTemp = logisticsFeeTemp + (serviceOrder.goodsShipping - serviceOrder.goodsShippingDisc)
        // 履约服务费
        serviceFeeTemp = serviceFeeTemp + serviceOrder.serviceCharge
        // 佣金
        commissionAmountTemp = commissionAmountTemp + serviceOrder.goodsCommission
      })
      this.commodityAmount = commodityAmountTemp.toFixed(2)
      this.logisticsFee = logisticsFeeTemp.toFixed(2)
      this.serviceFee = serviceFeeTemp.toFixed(2)
      this.commissionAmount = commissionAmountTemp.toFixed(2)
    },
    /**
     * 审核
     */
    reviewServiceOrder(reason) {
      this.actionLoading = true
      const params = {reason: reason}
      putAction('/order/api/v0.2/service-orders/review/' + this.serviceOrderId + '/' + this.action, params).then(response => {
        if (response.success) {
          this.actionLoading = false
          this.reason = ''
          this.back()
          //this.$router.push({path: 'service-order'})
          this.$router.go(0)
        } else {
          this.$message.warning(response.message)
          this.actionLoading = false
        }
      }).catch(err => {
        this.$message.warning(err)
        this.actionLoading = false
      })
    },
    backArbitrationVisible() {
      this.arbitrationVisible = false
    },
    showArbitrationVisible() {
      this.arbitrationVisible = true
    },
    back() {
      this.reviewVisible = false
    },
    // 审核通过或者拒绝弹框
    showReviewDialog(action) {
      this.action = action
      this.reviewVisible = true
    },
    countdown(date) {
      this.timer = setInterval(() => {
        this.show(date)
      }, 1000)
    },
    /**
     * 通过售后单发起仲裁的时间 + 3天 当做结束时间，当前时间为开始时间
     */
    show(endDate) {
    // 获取未来时间
      endDate = new Date(endDate.replace(/-/g, '/'))
      // 获取当前时间（日期精确到毫秒）
      let startDate = new Date()
      // 获取得出时间差
      var day = endDate.getTime() - startDate.getTime()
      if (day === 0) {
        clearInterval(this.timer)
        this.loadData()
      }
      var time = parseInt(day / (1000 * 60 * 60 * 24))
      var hour = parseInt((day % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      var minute = parseInt((day % (1000 * 60 * 60)) / (1000 * 60))
      var second = parseInt(day / 1000 % 60)
      const currentCountDow = {
        time: time,
        hour: hour,
        minute: minute,
        second: second
      }
      this.countDown = currentCountDow
    },
    beforeDestroy() {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  watch: {
    'refundHistory': {
      handler(newVal, oldVal) {
        // console.log(newVal)
        this.refundHistory = newVal
      },
      deep: true,
      immediate: true
    }

  }
}
</script>
<style lang="less" scoped>
.refund-audit-history{
  padding-top: 20px;
}
.history-title{
  padding: 0 20px;
}
.refund-audit-content{
  width: 100%;
  margin: 0 auto;
  border: 1px solid #e1e1e1;
  border-top: none;
  box-sizing: border-box;
  // padding-bottom: 20px;
}
.refund-succeess-row{
  display: flex;
  margin:10px 0px;
  font-family: Satoshi-Medium;
  .title{
    font-weight: 800;
    width:15%
  }
}
@media screen and (max-width: 1024px) {
  .refund-audit-content{
    width: 100% !important;
  }
}
.refund-audit-title{
  padding: 20px 20px 0 20px;
  div{
    padding-bottom: 20px;
    border-bottom: 1px solid #E1E1E1;
  }
}
.refund-audit-status{
  padding: 15px 20px 0 20px;
  .refund-audit-status-content{
    padding-bottom: 20px;
    border-bottom: 1px solid #E1E1E1;
  }
  .audit-status-edit{
    display: flex;
    padding-top: 21px;
    align-items: center;
    .audit-status-edit-button{
      width: 178px;
      height: 40px;
      background: #262613;
      border: 1px solid #707070;
      border-radius: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      cursor: pointer;
      margin-right:10px;
    }
    .audit-status-edit-button-refund{
      width: 178px;
      height: 40px;
      background: #FF4812;
      border: 1px solid #FF4812;
      border-radius: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      cursor: pointer;
      margin-right:10px;
    }
    .audit-status-edit-text{
      padding-left: 20px;
      text-decoration: underline;
      color: #262613;
    }
  }
}
.ash{
  color: #8F8F8F;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/service-order-detail.vue